import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);

  function getCookie(name) {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith(name + "="))
      ?.split("=")[1];
  }

  useEffect(() => {
    const checkAuth = async () => {
      const now = Date.now();
      const loginTime = parseInt(sessionStorage.getItem("loginTime") || "0", 10);
      const lastActivity = parseInt(sessionStorage.getItem("lastActivity") || "0", 10);
      const expiresIn = parseInt(sessionStorage.getItem("expiresIn") || "0", 10);

      if (now - loginTime > expiresIn * 60 * 1000) {
        sessionStorage.clear();
        setIsAuthorized(false);
        return;
      }

      if (now - lastActivity > 20 * 60 * 1000) {
        sessionStorage.clear();
        setIsAuthorized(false);
        return;
      }

      try {
        const csrfToken = getCookie("csrf_token");

        const res = await fetch("https://api.datasenseai-neuronize.charlizeonline.net/api/auth/perfil", {
          method: "GET",
          credentials: "include",
          headers: {
            "X-CSRF-Token": csrfToken,
          },
        });

        if (res.status === 401 || res.status === 403) {
          setIsAuthorized(false);
        } else {
          setIsAuthorized(true);
        }
      } catch (err) {
        setIsAuthorized(false);
      }

    };

    checkAuth();
    const interval = setInterval(checkAuth, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (isAuthorized === null) return null;
  return isAuthorized ? children : <Navigate to="/" />;
};

export default ProtectedRoute;